<template>
  <div v-if="visible" class="pinned-message-bar visible" @click="$emit('open-panel')">
    <div class="pinned-message-bar-inner">
      <div class="pinned-message-bar-left"></div>
      <div class="pinned-message-bar-copy">
        <div class="pinned-message-bar-label">置顶消息</div>
        <div class="pinned-message-bar-text">{{ latestText }}</div>
      </div>
      <span v-if="total > 1" class="pinned-message-bar-count">{{ total }} 条</span>
      <span class="pinned-message-bar-list-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M8 6h13M8 12h13M8 18h13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="4" cy="6" r="1.5" fill="currentColor"/><circle cx="4" cy="12" r="1.5" fill="currentColor"/><circle cx="4" cy="18" r="1.5" fill="currentColor"/></svg>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PinnedMessageBar',
  props: {
    pinnedKey: { type: String, default: '' }
  },
  computed: {
    list() {
      return this.$store.state.conversationPinnedMessages[this.pinnedKey] || []
    },
    total() { return this.list.length },
    dismissed() { return !!this.$store.state.pinnedBarDismissed[this.pinnedKey] },
    visible() { return this.total > 0 && !this.dismissed },
    latest() {
      // 后端按 pinnedAt 倒序，items[0] 即最新
      return this.list[0] || null
    },
    latestText() {
      const m = this.latest && this.latest.message
      if (!m) return ''
      const text = (m.body && (m.body.text || m.body.caption)) || m.text || ''
      let preview = String(text).replace(/\s+/g, ' ').trim()
      if (!preview) {
        // 文本为空时按文件类型兜底
        const files = (m.body && m.body.files) || m.files || []
        if (files.length > 1) {
          preview = `[${files.length} 个文件]`
        } else {
          const f = files[0] || {}
          const mime = (f.mimeType || f.type || '').toLowerCase()
          const name = (f.name || '').toLowerCase()
          if (mime.startsWith('image/') || /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(name)) preview = '[图片]'
          else if (mime.startsWith('video/') || /\.(mp4|webm|mov|avi|mkv)$/.test(name)) preview = '[视频]'
          else if (mime.startsWith('audio/') || /\.(mp3|wav|ogg|m4a|flac)$/.test(name)) preview = '[语音]'
          else if (f.url) preview = '[文件] ' + (f.name || '')
          else if (m.messageType === 'system' || m.kind === 'system') preview = '[系统消息]'
        }
      }
      return preview.length > 60 ? preview.slice(0, 60) + '…' : preview
    }
  }
}
</script>
